<template>
    <div>
        <loading :active.sync="loading.app" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Upgrade Akun</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" style="padding-bottom:65px;" v-if="loading.app == false">
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-1 pl-3 pr-3">
                    <h3>Upgrade Akun Kamu ke Qios Premium Sekarang!</h3>
                    <p>Dapatkan Berbagai Keuntungan dan Bonus yang Lebih Besar.</p>
                </div>
            </div>
            <div class="section full mt-1">
                <div class="listview-title pl-3 pr-3" style="font-weight:bold;">Keuntungan Qios Premium?</div>
                <ul class="listview simple-listview inset mb-5">
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b>Bonus / Cashback Transaksi</b>
                                <footer>Setiap Kamu melakukan transaksi, kamu berkesempatan mendapatkan Bonus Komisi hingga Rp 1.000* Per Transaksi</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b>Bonus Komisi Transaksi Downline Lebih Besar</b>
                                <footer>Setiap transaksi dari downline kamu, kamu akan mendapatkan bonus komisi sebesar Rp {{ setting.komisi_transaction_referral_premium }} pertransaksi</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b>Bonus Upgrade Downline</b>
                                <footer>Setiap Downline yang kamu miliki melakukan upgrade akun menjadi Qios Premium, kamu akan mendapatkan komisi sebesar Rp {{setting.komisi_upgrade_premium_from_referral | rupiah}}</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b>Fitur Premium</b>
                                <footer>Sebagai Qios Premium kamu dapat menggunakan fitur - fitur premium yang ada di aplikasi Qiosfin</footer>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item pl-1 pr-1">
                            <div>
                                <b>Prioritas layanan bantuan</b>
                                <footer>Kamu akan menjadi prioritas kami jika mengalami kendala dalam menggunakan aplikasi Qiosfin</footer>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="form-button-group shadow-header-footer" style="max-width:480px;margin:auto;">
                <button class="btn btn-primary btn-block btn-lg" @click="showDialog('show')">UPGRADE SEHARGA RP {{setting.biaya_upgrade_premium | rupiah}}</button>
            </div>
        </div>
        <loading-app v-else></loading-app>

        <Dialog ref="dialog" :loading="loading.dialog" :title="'Upgrade Qios Premium'" @confirm="submit()">
            <p>Anda akan melakukan upgrade akun dari Qios Member ke Qios Premium, saldo Anda akan di potong sebesar Rp {{ setting.biaya_upgrade_premium | rupiah }} sebagai biaya upgrade Qios Premium.</p>
            <p>Dengan melakukan upgrade akun maka Anda menyetujui <b class="text-primary">Syarat & Ketentuan</b> dan <b class="text-primary">Kebijakan Privasi</b> yang berlaku. Apakah Anda setuju?</p>
        </Dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.upgrade',
    data() {
        return {
            loading:{
                dialog: false,
                app: true
            }
        }
    },
    created() {
        this.loading.app = false
        if(Object.keys(this.setting).length == 0){
            this.loading.app = true
            this.getSetting().then(() => {
                this.loading.app = false
            }).catch(() => {
                this.loading.app = false
            })
        }
    },
    computed: {
        ...mapState(['customer','setting','toast'])
    },
    methods: {
        ...mapActions(['getSetting']),
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        submit(){
            this.loading.dialog = true
            this.$store.commit('SET_TOAST', {show:false})
            $axios.post('/upgrade').then((response) => {
                this.showDialog('hide')
                this.loading.dialog = false
                this.$store.commit('SET_CUSTOMER', response.data.data)
                this.$router.push({name:'account'})
            }).catch((error) => {
                this.showDialog('hide')
                this.loading.dialog = false
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
            })
        }
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
}
</script>